(function(){
    document.addEventListener('DOMContentLoaded', function(){
        var nav = document.getElementById('toptag');
            
        var body = document.querySelector('body');
        body.style.paddingTop = nav.clientHeight + 'px';
    })
    
    document.addEventListener('scroll', function(){
        var body = document.querySelector('body');
        var nav = document.getElementById('toptag');
        
        if (window.innerWidth > 880) {
            body.style.paddingTop = nav.clientHeight + 'px'
        }
            
        if(window.scrollY > nav.clientHeight){
            nav.classList.add('-scrolled');
        } else{
            nav.classList.remove('-scrolled')
        }
    })
    
    window.addEventListener('resize', function(){
    
        var body = document.querySelector('body');
        var nav = document.getElementById('toptag');
        body.style.paddingTop = nav.clientHeight + 'px';
    })
})();